import EditStaffForm from "../components/EditStaffForm";

export default function EditStaffPage() {
  return <EditStaffForm />;
}
